export const reduxKey = '@@modals';
export const actionPrefix = '@@MODALS';
